import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any[], callback: (any) => boolean): any[] {
    return value.filter(val => callback(val));
  }

}
